import React, { FC } from "react";

import OverviewText from "./components/OverviewText";
import OverviewCarousel from "./components/OverviewCarousel";
import { TContentHubSeriesOverviewProps } from "./types/ContentHubSeriesOverview.type";
import LazySection from "../../react-only-components/LazySection";
import ExperienceEditorComponentPlaceholder from "../../react-only-components/ExperienceEditorComponentPlaceholder";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import "./styles.scss";

const ContentHubSeriesOverview: FC<TContentHubSeriesOverviewProps> = (
  props
) => {
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const isPreview = props.sitecoreContext.pageState === "preview";
  const isPlaceholderShown = isEEActive || isPreview;

  return (
    <LazySection>
      {isPlaceholderShown ? (
        <ExperienceEditorComponentPlaceholder text="Content Hub Series Overview - Component Placeholder" />
      ) : (
        <section
          className="series-overview"
          id={props?.fields?.apiData?.id?.toString()}
        >
          <div className="series-overview__container">
            <OverviewCarousel {...props} />
            <OverviewText {...props} />
            {/* <ExpandableOverlay {...props} /> */}
          </div>
        </section>
      )}
    </LazySection>
  );
};

export default withSitecoreContext()(ContentHubSeriesOverview);
